module.exports = __webpack_public_path__ + "img/rauf-a.16196463.png";